var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 13 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.751051 0.21967C1.08579 -0.0732231 1.6285 -0.0732231 1.96323 0.21967L6.5 4.18934L11.0368 0.21967C11.3715 -0.073223 11.9142 -0.073223 12.2489 0.21967C12.5837 0.512563 12.5837 0.987437 12.2489 1.28033L7.10609 5.78033C6.77136 6.07322 6.22864 6.07322 5.89391 5.78033L0.751051 1.28033C0.416316 0.987437 0.416316 0.512563 0.751051 0.21967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e2b97c479aaed92c05ef61af52bf3afb.svg";
export { ForwardRef as ReactComponent };